import { Route } from "react-router-dom";

import ProducerStatistics from "../pages/ProducerStatistics";

export const statistics = <Route path="statistics" element={<ProducerStatistics />} />;
